import * as React from 'react';
import { StepProps, StepInternalProps } from './Stepper.types';
import { Text } from '../Text';

import classes from './Stepper.module.css';
import clsx from 'clsx';

export const Step = (props: StepProps) => {
    const { isDone, active, isLast, isNextActive } = props as StepInternalProps;

    const isHorizontal = props.orientation === 'horizontal' || props.orientation === undefined;
    const isHorizontalForHoelt = props.orientation === 'horizontal';

    return (
        <div
            style={{ width: '100%' }}
            className={isHorizontal ? classes['step-wrapper-horizontal'] : classes['step-wrapper-vertical']}
        >
            <div
                className={
                    isHorizontal ? classes['step-icon-wrapper-horizontal'] : classes['step-icon-wrapper-vertical']
                }
                data-testid="stepper-icon"
            >
                <div>
                    {props.icon ? (
                        <props.icon.type
                            isDone={isHorizontal ? isDone : false}
                            currentActive={isHorizontal ? active : false}
                            isInsideVerticalStepper={!isHorizontal}
                            isHorizontalForHoelt={isHorizontalForHoelt}
                        />
                    ) : (
                        <div className={classes['step-icon-default']} />
                    )}
                </div>
                {!isLast && (
                    <div
                        className={
                            isHorizontal
                                ? classes['separator-wrapper-horizontal']
                                : classes['separator-wrapper-vertical']
                        }
                    >
                        <div
                            className={clsx(
                                classes[isHorizontal ? 'step-separator-horizontal' : 'step-separator-vertical'],
                                {
                                    [classes['step-separator-active']]: isNextActive,
                                },
                            )}
                        />
                    </div>
                )}
            </div>
            <div
                className={clsx({
                    [classes['step-label']]: isHorizontal,
                    [classes['vertical']]: !isHorizontal,
                })}
                data-testid="stepper-label"
            >
                <div
                    className={clsx({
                        [classes['main-label']]: !isHorizontal,
                    })}
                >
                    <Text
                        text={props.label}
                        fontWeight="semibold"
                        variant={props.subLabel ? 'heading' : 'body'}
                       
                        disabled={isHorizontal ? !isDone : false}
                    />
                </div>
                {props.subLabel && (
                    <div
                        className={clsx({
                            [classes['step-sublabel']]: !isHorizontal,
                        })}
                    >
                        <Text text={props.subLabel}  fontWeight="regular" variant="body" disabled={isHorizontal ? !isDone : false}/>
                    </div>
                )}
            </div>
        </div>
    );
};
